module.exports = __webpack_public_path__ + "img/jr-hover.bef06a24.png";